import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onFinish", "children"];
import { VideoControls, VideoPlayer, VideoPlayerProvider } from '..';
import ContentControlWrapper from '../../../components/ContentControlWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const VideoPlayerWithControls = _ref => {
  let {
      onFinish,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(VideoPlayerProvider, {
    children: /*#__PURE__*/_jsxs(VideoPlayer, Object.assign({
      onFinish: onFinish
    }, props, {
      children: [/*#__PURE__*/_jsx(ContentControlWrapper, {
        children: /*#__PURE__*/_jsx(VideoControls, {
          onFinish: onFinish
        })
      }), children]
    }))
  });
};
export default VideoPlayerWithControls;